function CategoryModel(BaseModel, CategoryService) {
    'ngInject';

    class Category extends BaseModel {

        static $query(company) {
            return CategoryService.query(company);
        }
    }

    return Category;
}

/***
 * @ngdoc service
 * @name BB:Category
 *
 * @description
 * Representation of a Category Object
 *///
angular
    .module('BB')
    .service('CategoryModel', CategoryModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/category_model.service.js